import EthereumService from '@/services/ethereum'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
    this.kulapDex = options.kulapDex
  }

  async updateCurrentProvider () {
    const provider = this.getCurrentProvider()
    if (this.store.state.currentWalletProvider !== provider) {
      this.store.dispatch('setCurrentWalletProvider', provider)
    }
    return []
  }

  async intervalUpdateWalletWhenUserChange () {
    const wallets = await this.getWallets()
    if (wallets.length > 0) {
      this.store.dispatch('setWallets', wallets)
    }
    setTimeout(() => {
      this.intervalUpdateWalletWhenUserChange()
    }, 1000)
  }

  async getTokensAvaliable () {
    let { data } = await this.kulapApi.getAssetsAvaliable()
    data = data.filter(token => token !== 'DGX')
    this.store.dispatch('setTokensAvaliable', data)
  }

  async getAssetsProfile () {
    const { data } = await this.kulapApi.getAssetsProfile()
    this.store.dispatch('setTokensAssetsProfile', data)
  }

  async getCurentNetwork () {
    return this.kulapDex.getCurrentNetworkConnected()
  }
}



// WEBPACK FOOTER //
// ./src/pages/Exchange/service.js